/**
 * Created by DejanK on 1/11/2017.
 *
 * rbInputInteger
 */

'use strict';

module.exports = {
  template: templateFn,
  bindings: {
    model: '='
  }
};

templateFn.$inject = ['$attrs', 'RbInputTemplate'];
function templateFn($attrs, RbInputTemplate){

  let options = angular.extend(RbInputTemplate.readDefaultAttributes($attrs));

  return RbInputTemplate.integerTemplate(options);
}
